// /* eslint-disable */
// import React, { useEffect, useState, useRef, useCallback } from "react";
// import DateRangePicker from "react-bootstrap-daterangepicker";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faDownload,
//   faSearch,
//   faHome,
//   faArrowUp,
//   faArrowDown,
//   faCalendarAlt,
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { API_URL } from "../../config";
// import LoadingSpinner from "../../components/LoadingSpinner.jsx";
// import moment from "moment";
// import { Chart, registerables } from "chart.js";
// import Select from "react-select";

// Chart.register(...registerables);

// const RevenueChart = () => {
//   const [loading, setLoading] = useState(false);

//   // Data States
//   const [userList, setUserList] = useState([]);
//   const [chartData, setChartData] = useState({});
//   const [userWiseRevData, setUserWiseRevData] = useState([]);
//   const [monthWiseArr, setMonthWiseArr] = useState({});
//   const [serviceCountData, setServiceCountData] = useState({});
//   const [allDates, setAllDates] = useState([]);

//   // Meta Data for display
//   const [dateLabels, setDateLabels] = useState({
//     current: "",
//     previous: ""
//   });

//   // Chart References
//   const chartInstances = useRef({});

//   // --- Date Logic: Default to Current Week ---
//   const defaultStart = moment().startOf("isoWeek");
//   const defaultEnd = moment().endOf("isoWeek");
//   const defaultLabel = `${defaultStart.format("DD-MM-YYYY")} - ${defaultEnd.format("DD-MM-YYYY")}`;

//   // Form State
//   const [formInputs, setFormInputs] = useState({
//     created_on: defaultLabel,
//     screated_on: defaultStart,
//     ecreated_on: defaultEnd,
//     selecteduser: [],
//   });

//   // Ranges configuration
//   const ranges = {
//     "This Week": [moment().startOf("isoWeek"), moment().endOf("isoWeek")],
//     Today: [moment(), moment()],
//     Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
//     "Last 7 Days": [moment().subtract(6, "days"), moment()],
//     "Last 30 Days": [moment().subtract(29, "days"), moment()],
//     "This Month": [moment().startOf("month"), moment().endOf("month")],
//     "Last Month": [
//       moment().subtract(1, "month").startOf("month"),
//       moment().subtract(1, "month").endOf("month"),
//     ],
//     "This Year": [moment().startOf("year"), moment().endOf("year")],
//     "Last Year": [
//       moment().subtract(1, "year").startOf("year"),
//       moment().subtract(1, "year").endOf("year"),
//     ],
//   };

//   // Helper: Money Format
//   const moneyFormatIndia = (amount) => {
//     if (!amount) return "0.00";
//     const num = parseFloat(amount);
//     if (isNaN(num)) return "0.00";
//     return num.toLocaleString("en-IN", {
//       maximumFractionDigits: 2,
//       minimumFractionDigits: 2,
//     });
//   };

//   // 1. Fetch User List (GET)
//   const fetchUserList = async () => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await axios.get(`${API_URL}report-revenue/revenue`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           accept: "*/*",
//         },
//       });

//       if (response.data && response.data.userlist) {
//         const options = response.data.userlist.map((user) => ({
//           value: user.id,
//           label: user.user_fullname,
//         }));
//         setUserList(options);
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   // 2. Fetch Chart Data (POST)
//   const fetchRevenueChartData = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("authToken");

//       const payload = {
//         created_on: formInputs.created_on,
//         selecteduser: formInputs.selecteduser.length > 0
//           ? formInputs.selecteduser.map(u => u.value).join(',')
//           : ""
//       };

//       const response = await axios.post(
//         `${API_URL}report-revenue/revenue/chart`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//             accept: "*/*",
//           },
//         }
//       );

//       if (response.data) {
//         const data = response.data;
//         console.log("API Response:", data); // Debug log

//         setChartData(data.chartData || {});
//         setUserWiseRevData(data.userWiseRevData || []);
//         setMonthWiseArr(data.monthWiseArr || {});
//         setServiceCountData(data.serviceCountData || {});
//         setAllDates(data.allDates || []);

//         setDateLabels({
//           current: `${data.spay_date || ''} to ${data.epay_date || ''}`,
//           previous: `${data.prev_spay_date || ''} to ${data.prev_epay_date || ''}`
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching chart data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initial Load
//   useEffect(() => {
//     fetchUserList();
//     fetchRevenueChartData();
//     // eslint-disable-next-line
//   }, []);

//   // Chart Lifecycle
//   useEffect(() => {
//     if (chartData && Object.keys(chartData).length > 0 && allDates.length > 0) {
//       renderCharts();
//     }
//     return () => {
//       Object.values(chartInstances.current).forEach((chart) => {
//         if (chart && typeof chart.destroy === 'function') {
//           chart.destroy();
//         }
//       });
//       chartInstances.current = {};
//     };
//     // eslint-disable-next-line
//   }, [chartData, allDates]);

//   const renderCharts = () => {
//     // We only expect 'servicetype' based on the PHP code
//     const key = 'servicetype';
//     if (!chartData[key]) return;

//     const currentData = chartData[key];

//     // 1. Pie Chart
//     const pieCtx = document.getElementById(`pieChart_${key}`);
//     if (pieCtx) {
//       if (chartInstances.current[`pie_${key}`]) {
//         chartInstances.current[`pie_${key}`].destroy();
//       }

//       // Calculate pie chart data - sum of all piedata arrays
//       const pieLabels = Object.keys(currentData);
//       const pieData = pieLabels.map(label => {
//         const piedata = currentData[label].piedata;
//         if (Array.isArray(piedata)) {
//           return piedata.reduce((sum, val) => sum + parseFloat(val || 0), 0);
//         }
//         return parseFloat(piedata || 0);
//       });
//       const pieColors = pieLabels.map(label => currentData[label].color);

//       chartInstances.current[`pie_${key}`] = new Chart(pieCtx, {
//         type: 'pie',
//         data: {
//           labels: pieLabels,
//           datasets: [{
//             data: pieData,
//             backgroundColor: pieColors
//           }]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: { position: 'bottom' },
//             title: { display: true, text: 'Service Type' }
//           }
//         }
//       });
//     }

//     // 2. Bar Chart
//     const lineCtx = document.getElementById(`lineChart_${key}`);
//     if (lineCtx) {
//       if (chartInstances.current[`line_${key}`]) {
//         chartInstances.current[`line_${key}`].destroy();
//       }

//       // Transform data for Bar Chart
//       const datasets = Object.entries(currentData).map(([label, val]) => {
//         let dataArray = [];
//         if (typeof val.data === 'string') {
//           // Split comma-separated string and convert to numbers
//           dataArray = val.data.split(',').map(num => parseFloat(num || 0));
//         } else if (Array.isArray(val.data)) {
//           dataArray = val.data.map(num => parseFloat(num || 0));
//         }

//         // Ensure data array length matches allDates length
//         while (dataArray.length < allDates.length) {
//           dataArray.push(0);
//         }

//         return {
//           label: label,
//           backgroundColor: val.color,
//           data: dataArray.slice(0, allDates.length)
//         };
//       });

//       chartInstances.current[`line_${key}`] = new Chart(lineCtx, {
//         type: 'bar',
//         data: {
//           labels: allDates,
//           datasets: datasets
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: { position: 'bottom' },
//             title: { display: true, text: 'Service Type' },
//             tooltip: {
//               mode: 'index',
//               intersect: false,
//               callbacks: {
//                 label: function (context) {
//                   let label = context.dataset.label || '';
//                   if (label) {
//                     label += ': ';
//                   }
//                   if (context.parsed.y !== null) {
//                     label += moneyFormatIndia(context.parsed.y);
//                   }
//                   return label;
//                 }
//               }
//             }
//           },
//           scales: {
//             x: {
//               stacked: true,
//               grid: { display: false },
//               ticks: {
//                 maxRotation: 45,
//                 minRotation: 45
//               }
//             },
//             y: {
//               stacked: true,
//               beginAtZero: true,
//               ticks: {
//                 callback: function (value) {
//                   return moneyFormatIndia(value);
//                 }
//               }
//             }
//           }
//         }
//       });
//     }
//   };

//   // --- Handlers ---

//   const handleDateCallback = (event, picker) => {
//     const start = picker.startDate;
//     const end = picker.endDate;
//     const dateValue = `${start.format("DD-MM-YYYY")} - ${end.format("DD-MM-YYYY")}`;

//     setFormInputs((prev) => ({
//       ...prev,
//       created_on: dateValue,
//       screated_on: start,
//       ecreated_on: end,
//     }));
//   };

//   const handleUserChange = (selected) => {
//     setFormInputs((prev) => ({ ...prev, selecteduser: selected || [] }));
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchRevenueChartData();
//   };

//   // --- FIXED Calculation Logic (Matching PHP exactly) ---

//   const calculateDiff = (current, previous) => {
//     const curr = parseFloat(current || 0);
//     const prev = parseFloat(previous || 0);

//     // Match PHP logic exactly: only calculate if both values are non-zero
//     if (curr !== 0 && prev !== 0) {
//       return ((curr - prev) / prev) * 100;
//     }
//     return 0;
//   };

//   const formatPercentage = (value) => {
//     return parseFloat(value).toFixed(2);
//   };

//   const renderBadge = (diff, showAlways = false) => {
//     const val = parseFloat(diff);

//     // Match PHP logic: don't show badge if percentage is 0
//     if (val === 0 && !showAlways) return null;

//     const isNegative = val < 0;
//     const className = isNegative ? "badge badge-danger font-weight-normal" : "badge badge-success font-weight-normal";
//     const icon = isNegative ? faArrowDown : faArrowUp;
//     const sign = isNegative ? "" : "+";
//     const displayValue = formatPercentage(val);

//     return (
//       <span className={className} style={{ marginLeft: '5px', fontSize: '0.75em' }}>
//         <FontAwesomeIcon icon={icon} /> ({sign}{displayValue}%)
//       </span>
//     );
//   };

//   // Summary Box Calculations - MATCHING PHP LOGIC EXACTLY
//   const boxNewAfterRevenue = parseFloat(serviceCountData.new_after_revenue || 0);
//   const boxRenewalAfterRevenue = parseFloat(serviceCountData.renewal_after_revenue || 0);
//   const boxTotalAfterRevenue = boxNewAfterRevenue + boxRenewalAfterRevenue;

//   const boxNewBeforeRevenue = parseFloat(serviceCountData.new_before_revenue || 0);
//   const boxRenewalBeforeRevenue = parseFloat(serviceCountData.renewal_before_revenue || 0);
//   const boxTotalBeforeRevenue = boxNewBeforeRevenue + boxRenewalBeforeRevenue;

//   // Calculate percentages exactly like PHP
//   let boxTotalPercentageDifference = 0;
//   if (boxTotalAfterRevenue !== 0 && boxTotalBeforeRevenue !== 0) {
//     boxTotalPercentageDifference = ((boxTotalAfterRevenue - boxTotalBeforeRevenue) / boxTotalBeforeRevenue) * 100;
//   }
//   boxTotalPercentageDifference = formatPercentage(boxTotalPercentageDifference);

//   let boxNewPercentageDifference = 0;
//   if (boxNewAfterRevenue !== 0 && boxNewBeforeRevenue !== 0) {
//     boxNewPercentageDifference = ((boxNewAfterRevenue - boxNewBeforeRevenue) / boxNewBeforeRevenue) * 100;
//   }
//   boxNewPercentageDifference = formatPercentage(boxNewPercentageDifference);

//   let boxRenewalPercentageDifference = 0;
//   if (boxRenewalAfterRevenue !== 0 && boxRenewalBeforeRevenue !== 0) {
//     boxRenewalPercentageDifference = ((boxRenewalAfterRevenue - boxRenewalBeforeRevenue) / boxRenewalBeforeRevenue) * 100;
//   }
//   boxRenewalPercentageDifference = formatPercentage(boxRenewalPercentageDifference);

//   // Create HTML for boxes like PHP does
//   const boxTotalHtml = boxTotalPercentageDifference < 0
//     ? <>{moneyFormatIndia(boxTotalBeforeRevenue)} <span className="badge badge-danger font-weight-normal"> <FontAwesomeIcon icon={faArrowDown} /> ({boxTotalPercentageDifference}%) </span></>
//     : <>{moneyFormatIndia(boxTotalBeforeRevenue)} <span className="badge badge-success font-weight-normal"> <FontAwesomeIcon icon={faArrowUp} /> (+{boxTotalPercentageDifference}%) </span></>;

//   const boxNewAfterHtml = boxNewPercentageDifference < 0
//     ? <>{moneyFormatIndia(boxNewBeforeRevenue)} <span className="badge badge-danger font-weight-normal"> <FontAwesomeIcon icon={faArrowDown} /> ({boxNewPercentageDifference}%) </span></>
//     : <>{moneyFormatIndia(boxNewBeforeRevenue)} <span className="badge badge-success font-weight-normal"> <FontAwesomeIcon icon={faArrowUp} /> (+{boxNewPercentageDifference}%) </span></>;

//   const boxRenewalAfterHtml = boxRenewalPercentageDifference < 0
//     ? <>{moneyFormatIndia(boxRenewalBeforeRevenue)} <span className="badge badge-danger font-weight-normal"> <FontAwesomeIcon icon={faArrowDown} /> ({boxRenewalPercentageDifference}%) </span></>
//     : <>{moneyFormatIndia(boxRenewalBeforeRevenue)} <span className="badge badge-success font-weight-normal"> <FontAwesomeIcon icon={faArrowUp} /> (+{boxRenewalPercentageDifference}%) </span></>;

//   // Calculate pie chart total for display
//   const pieChartTotal = chartData.servicetype ?
//     Object.values(chartData.servicetype).reduce((sum, item) => {
//       if (Array.isArray(item.piedata)) {
//         return sum + item.piedata.reduce((a, b) => parseFloat(a || 0) + parseFloat(b || 0), 0);
//       }
//       return sum + parseFloat(item.piedata || 0);
//     }, 0) : 0;

//   // Table Footer Calculations
//   const footerTotals = userWiseRevData.reduce((acc, row) => {
//     const rowTotalAfter = parseFloat(row.new_after_revenue || 0) + parseFloat(row.renewal_after_revenue || 0);
//     const rowTotalBefore = parseFloat(row.new_before_revenue || 0) + parseFloat(row.renewal_before_revenue || 0);

//     return {
//       userTotal: acc.userTotal + (parseInt(row.subscribed_count) || parseInt(row.count) || 0),
//       totalAfter: acc.totalAfter + rowTotalAfter,
//       newAfter: acc.newAfter + parseFloat(row.new_after_revenue || 0),
//       renewalAfter: acc.renewalAfter + parseFloat(row.renewal_after_revenue || 0),
//       totalBefore: acc.totalBefore + rowTotalBefore,
//       newBefore: acc.newBefore + parseFloat(row.new_before_revenue || 0),
//       renewalBefore: acc.renewalBefore + parseFloat(row.renewal_before_revenue || 0),
//     };
//   }, { userTotal: 0, totalAfter: 0, newAfter: 0, renewalAfter: 0, totalBefore: 0, newBefore: 0, renewalBefore: 0 });

//   return (
//     <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
//       <link href="https://research.streetgains.in/dev/app/assets/daterangepicker.css" rel="stylesheet" />

//       {loading && <LoadingSpinner />}

//       {/* Breadcrumb */}
//       <div className="row pb-2">
//         <div className="col-md-3">
//           <ul className="breadcrumb">
//             <li className="breadcrumb-item">
//               <a href="/dashboard" style={{ textDecoration: "none" }}>
//                 <FontAwesomeIcon icon={faHome} /> Home
//               </a>
//             </li>
//             <li className="breadcrumb-item active">Revenue Chart</li>
//           </ul>
//         </div>
//       </div>

//       {/* Main Panel */}
//       <div className="panel panel-default with-rounded-corner with-shadow chartbox">
//         <div className="panel-heading"></div>
//         <div className="panel-body">

//           {/* Filters */}
//           <div className="row">
//             <div className="col-12">
//               <form onSubmit={handleSearch}>
//                 <div className="row align-items-center">
//                   <div className="col-md-2">
//                     <div className="form-group">
//                       <label className="control-label">Pay Date</label>
//                       <DateRangePicker
//                         initialSettings={{
//                           autoUpdateInput: false,
//                           locale: { format: "DD-MM-YYYY", cancelLabel: "Clear" },
//                           ranges: ranges,
//                           startDate: formInputs.screated_on,
//                           endDate: formInputs.ecreated_on,
//                         }}
//                         onApply={handleDateCallback}
//                       >
//                         <div className="input-group">
//                           <input
//                             type="text"
//                             className="form-control"
//                             value={formInputs.created_on}
//                             placeholder="Select Date Range"
//                             readOnly
//                           />
//                           <span className="input-group-addon" style={{ display: "flex", alignItems: "center", padding: "0 10px", background: "#eee", border: "1px solid #ced4da", borderLeft: "none" }}>
//                             <FontAwesomeIcon icon={faCalendarAlt} />
//                           </span>
//                         </div>
//                       </DateRangePicker>
//                     </div>
//                   </div>

//                   <div className="col-md-2">
//                     <div className="form-group">
//                       <label className="control-label">User</label>
//                       <Select
//                         isMulti
//                         options={userList}
//                         value={formInputs.selecteduser}
//                         onChange={handleUserChange}
//                         placeholder="Select User"
//                         classNamePrefix="react-select"
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-2">
//                     <div className="form-group">
//                       <label className="control-label w-100"></label>
//                       <button type="submit" className="btn btn-default">
//                         <FontAwesomeIcon icon={faSearch} />
//                       </button>
//                     </div>
//                   </div>

//                   <div className="col-md-6">
//                     <button type="button" className="btn btn-default btn-sm pull-right">
//                       <FontAwesomeIcon icon={faDownload} /> Export Report
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>

//           {/* Summary Boxes - FIXED */}
//           <div className="row mb-4">
//             <div className="col-sm-4">
//               <a href="#" className="widget widget-stats bg-gradient-blue-dark inverse-mode">
//                 <div className="widget-stats-left">
//                   <div className="widget-stats-title">Total Revenue</div>
//                 </div>
//                 <div className="widget-stats-right">
//                   <div className="widget-stats-value"> {moneyFormatIndia(boxTotalAfterRevenue)} </div>
//                   {boxTotalHtml}
//                 </div>
//               </a>
//             </div>
//             <div className="col-sm-4">
//               <a href="#" className="widget widget-stats bg-gradient-orange inverse-mode">
//                 <div className="widget-stats-left">
//                   <div className="widget-stats-title">New Revenue</div>
//                 </div>
//                 <div className="widget-stats-right">
//                   <div className="widget-stats-value"> {moneyFormatIndia(boxNewAfterRevenue)} </div>
//                   {boxNewAfterHtml}
//                 </div>
//               </a>
//             </div>
//             <div className="col-sm-4">
//               <a href="#" className="widget widget-stats bg-gradient-red inverse-mode">
//                 <div className="widget-stats-left">
//                   <div className="widget-stats-title">Renewal Revenue</div>
//                 </div>
//                 <div className="widget-stats-right">
//                   <div className="widget-stats-value"> {moneyFormatIndia(boxRenewalAfterRevenue)} </div>
//                   {boxRenewalAfterHtml}
//                 </div>
//               </a>
//             </div>
//           </div>

//           {/* Charts Area */}
//           <div className="row">
//             {chartData.servicetype && (
//               <>
//                 <div className="col-sm-6 mb-3">
//                   <div className="pie_chart_wrap">
//                     <div className="pie_chart_div" style={{ height: "300px", position: "relative" }}>
//                       <canvas id="pieChart_servicetype"></canvas>
//                     </div>
//                     <div className="total_value_div text-center">
//                       <label>Total Revenue: <span>{moneyFormatIndia(pieChartTotal)}</span></label>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-sm-6">
//                   <div style={{ height: "300px", position: "relative" }}>
//                     <canvas id="lineChart_servicetype"></canvas>
//                   </div>
//                 </div>
//               </>
//             )}
//           </div>

//           {/* User Revenue Table - FIXED */}
//           <div className="row mt-5">
//             <div className="col-12">
//               <div className="table-responsive">
//                 <table className="table table-condensed table-hover bg-white">
//                   <thead>
//                     <tr align="center">
//                       <th rowSpan="2">User</th>
//                       <th colSpan="3">Current - {dateLabels.current}</th>
//                       <th rowSpan="2">Difference</th>
//                       <th colSpan="3">Previous - {dateLabels.previous}</th>
//                     </tr>
//                     <tr>
//                       <th>New User</th>
//                       <th>Total Revenue</th>
//                       <th>New Revenue</th>
//                       <th>Renewal Revenue</th>
//                       <th>Total Revenue</th>
//                       <th>New Revenue</th>
//                       <th>Renewal Revenue</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {userWiseRevData.map((row, idx) => {
//                       const totalBeforeRevenue = (parseFloat(row.new_before_revenue || 0) + parseFloat(row.renewal_before_revenue || 0));
//                       const totalAfterRevenue = (parseFloat(row.new_after_revenue || 0) + parseFloat(row.renewal_after_revenue || 0));

//                       // Calculate percentages exactly like PHP
//                       let totalPercentageDifference = 0;
//                       if (totalAfterRevenue !== 0 && totalBeforeRevenue !== 0) {
//                         totalPercentageDifference = ((totalAfterRevenue - totalBeforeRevenue) / totalBeforeRevenue) * 100;
//                       }
//                       totalPercentageDifference = formatPercentage(totalPercentageDifference);

//                       const newBeforeRevenue = parseFloat(row.new_before_revenue || 0);
//                       const newAfterRevenue = parseFloat(row.new_after_revenue || 0);
//                       let newPercentageDifference = 0;
//                       if (newAfterRevenue !== 0 && newBeforeRevenue !== 0) {
//                         newPercentageDifference = ((newAfterRevenue - newBeforeRevenue) / newBeforeRevenue) * 100;
//                       }
//                       newPercentageDifference = formatPercentage(newPercentageDifference);

//                       const renewalBeforeRevenue = parseFloat(row.renewal_before_revenue || 0);
//                       const renewalAfterRevenue = parseFloat(row.renewal_after_revenue || 0);
//                       let renewalPercentageDifference = 0;
//                       if (renewalAfterRevenue !== 0 && renewalBeforeRevenue !== 0) {
//                         renewalPercentageDifference = ((renewalAfterRevenue - renewalBeforeRevenue) / renewalBeforeRevenue) * 100;
//                       }
//                       renewalPercentageDifference = formatPercentage(renewalPercentageDifference);

//                       // Create HTML like PHP does
//                       const renewalAfterHtml = renewalPercentageDifference < 0
//                         ? <span className="text-danger"> <FontAwesomeIcon icon={faArrowDown} /> ({renewalPercentageDifference}%) </span>
//                         : <span className="text-success"> <FontAwesomeIcon icon={faArrowUp} /> (+{renewalPercentageDifference}%) </span>;

//                       const newAfterHtml = newPercentageDifference < 0
//                         ? <span className="text-danger"> <FontAwesomeIcon icon={faArrowDown} /> ({newPercentageDifference}%) </span>
//                         : <span className="text-success"> <FontAwesomeIcon icon={faArrowUp} /> (+{newPercentageDifference}%) </span>;

//                       const totalHtml = totalPercentageDifference < 0
//                         ? <span className="text-danger"> <FontAwesomeIcon icon={faArrowDown} /> ({totalPercentageDifference}%) </span>
//                         : <span className="text-success"> <FontAwesomeIcon icon={faArrowUp} /> (+{totalPercentageDifference}%) </span>;

//                       // Show empty if percentage is 0 (like PHP)
//                       const displayNewAfterHtml = (parseFloat(newPercentageDifference) === 0) ? '' : newAfterHtml;
//                       const displayRenewalAfterHtml = (parseFloat(renewalPercentageDifference) === 0) ? '' : renewalAfterHtml;
//                       const displayTotalHtml = (parseFloat(totalPercentageDifference) === 0) ? '' : totalHtml;

//                       return (
//                         <tr key={idx}>
//                           <td>{row.sales_manager_name}</td>
//                           <td>{row.subscribed_count || row.count || 0}</td>
//                           <td data-sort={totalAfterRevenue}>{moneyFormatIndia(totalAfterRevenue)}</td>
//                           <td data-sort={newAfterRevenue}>{moneyFormatIndia(newAfterRevenue)} {displayNewAfterHtml}</td>
//                           <td data-sort={renewalAfterRevenue}>{moneyFormatIndia(renewalAfterRevenue)} {displayRenewalAfterHtml}</td>
//                           <td>{displayTotalHtml}</td>
//                           <td data-sort={totalBeforeRevenue}>{moneyFormatIndia(totalBeforeRevenue)}</td>
//                           <td data-sort={newBeforeRevenue}>{moneyFormatIndia(newBeforeRevenue)}</td>
//                           <td data-sort={renewalBeforeRevenue}>{moneyFormatIndia(renewalBeforeRevenue)}</td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                   <tfoot>
//                     <tr>
//                       <th>Total</th>
//                       <th>{footerTotals.userTotal}</th>
//                       <th>{moneyFormatIndia(footerTotals.totalAfter)}</th>
//                       <th>{moneyFormatIndia(footerTotals.newAfter)}</th>
//                       <th>{moneyFormatIndia(footerTotals.renewalAfter)}</th>
//                       <th></th>
//                       <th>{moneyFormatIndia(footerTotals.totalBefore)}</th>
//                       <th>{moneyFormatIndia(footerTotals.newBefore)}</th>
//                       <th>{moneyFormatIndia(footerTotals.renewalBefore)}</th>
//                     </tr>
//                   </tfoot>
//                 </table>
//               </div>
//             </div>
//           </div>

//           {/* Month Wise Data */}
//           <div className="row mt-5">
//             {Object.keys(monthWiseArr).length > 0 && Object.entries(monthWiseArr).map(([userId, months]) => {
//               if (typeof months !== 'object' || months === null) return null;

//               const monthEntries = Object.entries(months);
//               if (monthEntries.length === 0) return null;

//               const totals = monthEntries.reduce((acc, [monthKey, data]) => ({
//                 total: acc.total + parseFloat(data.amount || 0),
//                 new: acc.new + parseFloat(data.new_revenue || 0),
//                 renewal: acc.renewal + parseFloat(data.renewal_revenue || 0)
//               }), { total: 0, new: 0, renewal: 0 });

//               const userName = monthEntries[0]?.[1]?.user_fullname || 'Overall Data';

//               return (
//                 <div className="col-md-6 mt-4" key={userId}>
//                   <h4>{formInputs.selecteduser.length === 0 ? 'Overall Data Month Wise' : userName}</h4>
//                   <div className="table-responsive">
//                     <table className="table">
//                       <thead>
//                         <tr>
//                           <th>Months</th>
//                           <th>Total Revenue</th>
//                           <th>New Revenue</th>
//                           <th>Renewal Revenue</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {monthEntries.map(([month, data]) => (
//                           <tr key={month}>
//                             <td>{month}</td>
//                             <td>{moneyFormatIndia(data.amount)}</td>
//                             <td>{moneyFormatIndia(data.new_revenue)}</td>
//                             <td>{moneyFormatIndia(data.renewal_revenue)}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                       <tfoot>
//                         <tr>
//                           <th>Total</th>
//                           <th>{moneyFormatIndia(totals.total)}</th>
//                           <th>{moneyFormatIndia(totals.new)}</th>
//                           <th>{moneyFormatIndia(totals.renewal)}</th>
//                         </tr>
//                       </tfoot>
//                     </table>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//         </div>
//       </div>

//       <style jsx>{`
//         .breadcrumb { background: transparent; margin-bottom: 0; padding: 0; list-style: none; display: flex; align-items: center; }
//         .breadcrumb-item { display: flex; align-items: center; }
//         .breadcrumb-item + .breadcrumb-item::before { content: ">"; padding: 0 8px; color: #6c757d; }
//         .breadcrumb-item a { color: #007bff; text-decoration: none; }
//         .breadcrumb-item.active { color: #6c757d; }

//         .panel { background: white; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
//         .with-rounded-corner { border-radius: 4px; }
//         .with-shadow { box-shadow: 0 1px 3px rgba(0,0,0,0.1); }

//         .widget-stats {
//           padding: 15px; border-radius: 4px; color: white; overflow: hidden; margin-bottom: 20px; min-height: 80px;
//           display: flex; justify-content: space-between; align-items: center; text-decoration: none;
//         }
//         .widget-stats:hover { color: #fff; opacity: 0.95; }
//         .widget-stats-left { text-align: left; }
//         .widget-stats-right { text-align: right; }
//         .widget-stats-title { font-size: 12px; opacity: 0.8; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;}
//         .widget-stats-value { font-size: 24px; font-weight: bold; }
//         .desc-value { font-size: 13px; opacity: 0.9; margin-top: 2px; }

//         .bg-gradient-blue-dark { background: linear-gradient(45deg, #2c3e50, #3498db); }
//         .bg-gradient-orange { background: linear-gradient(45deg, #e67e22, #f39c12); }
//         .bg-gradient-red { background: linear-gradient(45deg, #e74c3c, #c0392b); }
//         .inverse-mode { color: white; }

//         .pie_chart_wrap { position: relative; }
//         .total_value_div { margin-top: 10px; font-weight: bold; }
//         .total_value_div span { font-weight: 700; }

//         .badge { font-size: 0.7em; margin-left: 5px; padding: 3px 6px; border-radius: 4px; }
//         .badge-danger { background-color: #ff5b57; color: #fff; }
//         .badge-success { background-color: #32a932; color: #fff; }

//         .form-group { margin-bottom: 1rem; }
//         .control-label { font-weight: 600; margin-bottom: 0.5rem; display: block; }
//         .btn-default { background-color: #f8f9fa; border-color: #ddd; color: #333; }
//         .btn-default:hover { background-color: #e9ecef; border-color: #ccc; }

//         .input-group { display: flex; width: 100%; }
//         .input-group .form-control { border-top-right-radius: 0; border-bottom-right-radius: 0; cursor: pointer; background: #fff !important; }
//         .input-group-addon { border-top-right-radius: 4px; border-bottom-right-radius: 4px; }

//         table { width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse; }
//         .table-condensed td, .table-condensed th { padding: 5px; }
//         .table-hover tbody tr:hover { color: #212529; background-color: rgba(0,0,0,.075); }
//         .bg-white { background-color: #fff !important; }
//         th { text-align: center; vertical-align: middle !important; border-bottom: 2px solid #dee2e6; }
//         td { text-align: center; vertical-align: middle; border-top: 1px solid #dee2e6; }
//         tfoot th { border-top: 2px solid #dee2e6; }

//         .text-danger { color: #dc3545 !important; }
//         .text-success { color: #28a745 !important; }
//       `}</style>
//     </div>
//   );
// };

// export default RevenueChart;



// /* eslint-disable */
// import React, { useEffect, useState, useRef, useCallback } from "react";
// import DateRangePicker from "react-bootstrap-daterangepicker";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faDownload,
//   faSearch,
//   faHome,
//   faArrowUp,
//   faArrowDown,
//   faCalendarAlt,
//   faSortUp,
//   faSortDown,
//   faSort,
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { API_URL } from "../../config";
// import LoadingSpinner from "../../components/LoadingSpinner.jsx";
// import moment from "moment";
// import { Chart, registerables } from "chart.js";
// import Select from "react-select";

// Chart.register(...registerables);

// const RevenueChart = () => {
//   const [loading, setLoading] = useState(false);

//   // Data States
//   const [userList, setUserList] = useState([]);
//   const [chartData, setChartData] = useState({});
//   const [userWiseRevData, setUserWiseRevData] = useState([]);
//   const [monthWiseArr, setMonthWiseArr] = useState({});
//   const [serviceCountData, setServiceCountData] = useState({});
//   const [allDates, setAllDates] = useState([]);

//   // Sorting States
//   const [sortField, setSortField] = useState("");
//   const [sortOrder, setSortOrder] = useState("");

//   // Meta Data for display
//   const [dateLabels, setDateLabels] = useState({
//     current: "",
//     previous: ""
//   });

//   // Chart References
//   const chartInstances = useRef({});

//   // --- Date Logic: Default to Current Week ---
//   const defaultStart = moment().startOf("isoWeek");
//   const defaultEnd = moment().endOf("isoWeek");
//   const defaultLabel = `${defaultStart.format("DD-MM-YYYY")} - ${defaultEnd.format("DD-MM-YYYY")}`;

//   // Form State
//   const [formInputs, setFormInputs] = useState({
//     created_on: defaultLabel,
//     screated_on: defaultStart,
//     ecreated_on: defaultEnd,
//     selecteduser: [],
//   });

//   // Ranges configuration
//   const ranges = {
//     "This Week": [moment().startOf("isoWeek"), moment().endOf("isoWeek")],
//     Today: [moment(), moment()],
//     Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
//     "Last 7 Days": [moment().subtract(6, "days"), moment()],
//     "Last 30 Days": [moment().subtract(29, "days"), moment()],
//     "This Month": [moment().startOf("month"), moment().endOf("month")],
//     "Last Month": [
//       moment().subtract(1, "month").startOf("month"),
//       moment().subtract(1, "month").endOf("month"),
//     ],
//     "This Year": [moment().startOf("year"), moment().endOf("year")],
//     "Last Year": [
//       moment().subtract(1, "year").startOf("year"),
//       moment().subtract(1, "year").endOf("year"),
//     ],
//   };

//   // Helper: Money Format
//   const moneyFormatIndia = (amount) => {
//     if (amount === null || amount === undefined || amount === "") return "0.00";
//     const num = parseFloat(amount);
//     if (isNaN(num)) return "0.00";
//     return num.toLocaleString("en-IN", {
//       maximumFractionDigits: 2,
//       minimumFractionDigits: 2,
//     });
//   };

//   // 1. Fetch User List (GET)
//   const fetchUserList = async () => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await axios.get(`${API_URL}report-revenue/revenue`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           accept: "*/*",
//         },
//       });

//       if (response.data && response.data.userlist) {
//         const options = response.data.userlist.map((user) => ({
//           value: user.id,
//           label: user.user_fullname,
//         }));
//         setUserList(options);
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   // 2. Fetch Chart Data (POST)
//   const fetchRevenueChartData = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("authToken");

//       const payload = {
//         created_on: formInputs.created_on,
//         selecteduser: formInputs.selecteduser.length > 0
//           ? formInputs.selecteduser.map(u => u.value).join(',')
//           : ""
//       };

//       const response = await axios.post(
//         `${API_URL}report-revenue/revenue/chart`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//             accept: "*/*",
//           },
//         }
//       );

//       if (response.data) {
//         const data = response.data;
//         console.log("API Response:", data); // Debug log

//         setChartData(data.chartData || {});
//         setUserWiseRevData(data.userWiseRevData || []);
//         setMonthWiseArr(data.monthWiseArr || {});
//         setServiceCountData(data.serviceCountData || {});
//         setAllDates(data.allDates || []);

//         setDateLabels({
//           current: `${data.spay_date || ''} to ${data.epay_date || ''}`,
//           previous: `${data.prev_spay_date || ''} to ${data.prev_epay_date || ''}`
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching chart data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initial Load
//   useEffect(() => {
//     fetchUserList();
//     fetchRevenueChartData();
//     // eslint-disable-next-line
//   }, []);

//   // Chart Lifecycle
//   useEffect(() => {
//     if (chartData && Object.keys(chartData).length > 0 && allDates.length > 0) {
//       renderCharts();
//     }
//     return () => {
//       Object.values(chartInstances.current).forEach((chart) => {
//         if (chart && typeof chart.destroy === 'function') {
//           chart.destroy();
//         }
//       });
//       chartInstances.current = {};
//     };
//     // eslint-disable-next-line
//   }, [chartData, allDates]);

//   const renderCharts = () => {
//     // We only expect 'servicetype' based on the PHP code
//     const key = 'servicetype';
//     if (!chartData[key]) return;

//     const currentData = chartData[key];

//     // 1. Pie Chart
//     const pieCtx = document.getElementById(`pieChart_${key}`);
//     if (pieCtx) {
//       if (chartInstances.current[`pie_${key}`]) {
//         chartInstances.current[`pie_${key}`].destroy();
//       }

//       // Calculate pie chart data - sum of all piedata arrays
//       const pieLabels = Object.keys(currentData);
//       const pieData = pieLabels.map(label => {
//         const piedata = currentData[label].piedata;
//         if (Array.isArray(piedata)) {
//           return piedata.reduce((sum, val) => sum + parseFloat(val || 0), 0);
//         }
//         return parseFloat(piedata || 0);
//       });
//       const pieColors = pieLabels.map(label => currentData[label].color);

//       chartInstances.current[`pie_${key}`] = new Chart(pieCtx, {
//         type: 'pie',
//         data: {
//           labels: pieLabels,
//           datasets: [{
//             data: pieData,
//             backgroundColor: pieColors
//           }]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: { position: 'bottom' },
//             title: { display: true, text: 'Service Type' }
//           }
//         }
//       });
//     }

//     // 2. Bar Chart
//     const lineCtx = document.getElementById(`lineChart_${key}`);
//     if (lineCtx) {
//       if (chartInstances.current[`line_${key}`]) {
//         chartInstances.current[`line_${key}`].destroy();
//       }

//       // Transform data for Bar Chart
//       const datasets = Object.entries(currentData).map(([label, val]) => {
//         let dataArray = [];
//         if (typeof val.data === 'string') {
//           // Split comma-separated string and convert to numbers
//           dataArray = val.data.split(',').map(num => parseFloat(num || 0));
//         } else if (Array.isArray(val.data)) {
//           dataArray = val.data.map(num => parseFloat(num || 0));
//         }

//         // Ensure data array length matches allDates length
//         while (dataArray.length < allDates.length) {
//           dataArray.push(0);
//         }

//         return {
//           label: label,
//           backgroundColor: val.color,
//           data: dataArray.slice(0, allDates.length)
//         };
//       });

//       chartInstances.current[`line_${key}`] = new Chart(lineCtx, {
//         type: 'bar',
//         data: {
//           labels: allDates,
//           datasets: datasets
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: { position: 'bottom' },
//             title: { display: true, text: 'Service Type' },
//             tooltip: {
//               mode: 'index',
//               intersect: false,
//               callbacks: {
//                 label: function (context) {
//                   let label = context.dataset.label || '';
//                   if (label) {
//                     label += ': ';
//                   }
//                   if (context.parsed.y !== null) {
//                     label += moneyFormatIndia(context.parsed.y);
//                   }
//                   return label;
//                 }
//               }
//             }
//           },
//           scales: {
//             x: {
//               stacked: true,
//               grid: { display: false },
//               ticks: {
//                 maxRotation: 45,
//                 minRotation: 45
//               }
//             },
//             y: {
//               stacked: true,
//               beginAtZero: true,
//               ticks: {
//                 callback: function (value) {
//                   return moneyFormatIndia(value);
//                 }
//               }
//             }
//           }
//         }
//       });
//     }
//   };

//   // --- Handlers ---

//   const handleDateCallback = (event, picker) => {
//     const start = picker.startDate;
//     const end = picker.endDate;
//     const dateValue = `${start.format("DD-MM-YYYY")} - ${end.format("DD-MM-YYYY")}`;

//     setFormInputs((prev) => ({
//       ...prev,
//       created_on: dateValue,
//       screated_on: start,
//       ecreated_on: end,
//     }));
//   };

//   const handleUserChange = (selected) => {
//     setFormInputs((prev) => ({ ...prev, selecteduser: selected || [] }));
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchRevenueChartData();
//   };

//   // --- Sorting Functions ---

//   const sortBox = (field) => {
//     if (sortField === field) {
//       // Toggle sort order if same field
//       const newOrder = sortOrder === "asc" ? "desc" : "asc";
//       setSortOrder(newOrder);
//     } else {
//       // Set new field with ascending order
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const getSortIcon = (field) => {
//     if (sortField === field) {
//       return sortOrder === "asc" ? faSortUp : faSortDown;
//     }
//     return faSort; // default icon for inactive columns
//   };

//   const sortData = (data) => {
//     if (!sortField || !sortOrder) return data;

//     return [...data].sort((a, b) => {
//       let aValue, bValue;

//       switch (sortField) {
//         case "user":
//           aValue = a.sales_manager_name || "";
//           bValue = b.sales_manager_name || "";
//           break;
//         case "subscribed_count":
//           aValue = parseInt(a.subscribed_count || a.count || 0);
//           bValue = parseInt(b.subscribed_count || b.count || 0);
//           break;
//         case "total_after":
//           aValue = parseFloat(a.new_after_revenue || 0) + parseFloat(a.renewal_after_revenue || 0);
//           bValue = parseFloat(b.new_after_revenue || 0) + parseFloat(b.renewal_after_revenue || 0);
//           break;
//         case "new_after":
//           aValue = parseFloat(a.new_after_revenue || 0);
//           bValue = parseFloat(b.new_after_revenue || 0);
//           break;
//         case "renewal_after":
//           aValue = parseFloat(a.renewal_after_revenue || 0);
//           bValue = parseFloat(b.renewal_after_revenue || 0);
//           break;
//         case "total_before":
//           aValue = parseFloat(a.new_before_revenue || 0) + parseFloat(a.renewal_before_revenue || 0);
//           bValue = parseFloat(b.new_before_revenue || 0) + parseFloat(b.renewal_before_revenue || 0);
//           break;
//         case "new_before":
//           aValue = parseFloat(a.new_before_revenue || 0);
//           bValue = parseFloat(b.new_before_revenue || 0);
//           break;
//         case "renewal_before":
//           aValue = parseFloat(a.renewal_before_revenue || 0);
//           bValue = parseFloat(b.renewal_before_revenue || 0);
//           break;
//         default:
//           return 0;
//       }

//       // Handle string comparison
//       if (typeof aValue === "string") {
//         return sortOrder === "asc"
//           ? aValue.localeCompare(bValue)
//           : bValue.localeCompare(aValue);
//       }

//       // Handle numeric comparison
//       return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
//     });
//   };

//   // --- CORRECTED Percentage Calculation Logic (Matching PHP exactly) ---

//   const calculatePercentage = (afterValue, beforeValue) => {
//     // Convert to numbers
//     const after = parseFloat(afterValue) || 0;
//     const before = parseFloat(beforeValue) || 0;

//     // IMPORTANT: PHP logic - Only calculate if BOTH values are non-zero
//     // if($boxTotalAfterRevenue != 0 && $boxTotalBeforeRevenue != 0){
//     //     $boxTotalPercentageDifference = ($boxTotalAfterRevenue !== 0) ? (($boxTotalAfterRevenue - $boxTotalBeforeRevenue) / $boxTotalBeforeRevenue) * 100 : 0;
//     // }

//     if (after !== 0 && before !== 0) {
//       return ((after - before) / before) * 100;
//     }
//     return 0;
//   };

//   const formatPercentage = (value) => {
//     const num = parseFloat(value);
//     if (isNaN(num)) return "0.00";
//     return num.toFixed(2);
//   };

//   const renderPercentageBadge = (percentage, isLeftSide = false) => {
//     const perc = parseFloat(percentage);

//     // Don't show if percentage is 0
//     if (perc === 0) return null;

//     const isNegative = perc < 0;
//     const className = isNegative
//       ? "badge badge-danger font-weight-normal"
//       : "badge badge-success font-weight-normal";
//     const icon = isNegative ? faArrowDown : faArrowUp;
//     const sign = perc < 0 ? "" : "+";
//     const displayValue = formatPercentage(perc);

//     if (isLeftSide) {
//       // For left side display (in summary boxes)
//       return (
//         <span className={className} style={{ marginLeft: '5px', fontSize: '0.75em' }}>
//           <FontAwesomeIcon icon={icon} /> ({sign}{displayValue}%)
//         </span>
//       );
//     } else {
//       // For right side display (in table)
//       return (
//         <span className={isNegative ? "text-danger" : "text-success"} style={{ marginLeft: '5px' }}>
//           <FontAwesomeIcon icon={icon} /> ({sign}{displayValue}%)
//         </span>
//       );
//     }
//   };

//   // Summary Box Calculations - CORRECTED to match PHP exactly
//   const calculateSummaryData = () => {
//     const boxNewAfterRevenue = parseFloat(serviceCountData.new_after_revenue || 0);
//     const boxRenewalAfterRevenue = parseFloat(serviceCountData.renewal_after_revenue || 0);
//     const boxTotalAfterRevenue = boxNewAfterRevenue + boxRenewalAfterRevenue;

//     const boxNewBeforeRevenue = parseFloat(serviceCountData.new_before_revenue || 0);
//     const boxRenewalBeforeRevenue = parseFloat(serviceCountData.renewal_before_revenue || 0);
//     const boxTotalBeforeRevenue = boxNewBeforeRevenue + boxRenewalBeforeRevenue;

//     // Calculate percentages exactly like PHP
//     const boxTotalPercentage = calculatePercentage(boxTotalAfterRevenue, boxTotalBeforeRevenue);
//     const boxNewPercentage = calculatePercentage(boxNewAfterRevenue, boxNewBeforeRevenue);
//     const boxRenewalPercentage = calculatePercentage(boxRenewalAfterRevenue, boxRenewalBeforeRevenue);

//     return {
//       boxNewAfterRevenue,
//       boxRenewalAfterRevenue,
//       boxTotalAfterRevenue,
//       boxNewBeforeRevenue,
//       boxRenewalBeforeRevenue,
//       boxTotalBeforeRevenue,
//       boxTotalPercentage,
//       boxNewPercentage,
//       boxRenewalPercentage
//     };
//   };

//   const summaryData = calculateSummaryData();

//   // Calculate pie chart total for display
//   const pieChartTotal = chartData.servicetype ?
//     Object.values(chartData.servicetype).reduce((sum, item) => {
//       if (Array.isArray(item.piedata)) {
//         return sum + item.piedata.reduce((a, b) => parseFloat(a || 0) + parseFloat(b || 0), 0);
//       }
//       return sum + parseFloat(item.piedata || 0);
//     }, 0) : 0;

//   // Table Footer Calculations
//   const calculateFooterTotals = () => {
//     return userWiseRevData.reduce((acc, row) => {
//       const subscribedCount = parseInt(row.subscribed_count || row.count || 0);
//       const newAfter = parseFloat(row.new_after_revenue || 0);
//       const renewalAfter = parseFloat(row.renewal_after_revenue || 0);
//       const newBefore = parseFloat(row.new_before_revenue || 0);
//       const renewalBefore = parseFloat(row.renewal_before_revenue || 0);

//       return {
//         userTotal: acc.userTotal + (isNaN(subscribedCount) ? 0 : subscribedCount),
//         totalAfter: acc.totalAfter + (newAfter + renewalAfter),
//         newAfter: acc.newAfter + newAfter,
//         renewalAfter: acc.renewalAfter + renewalAfter,
//         totalBefore: acc.totalBefore + (newBefore + renewalBefore),
//         newBefore: acc.newBefore + newBefore,
//         renewalBefore: acc.renewalBefore + renewalBefore,
//       };
//     }, {
//       userTotal: 0,
//       totalAfter: 0,
//       newAfter: 0,
//       renewalAfter: 0,
//       totalBefore: 0,
//       newBefore: 0,
//       renewalBefore: 0
//     });
//   };

//   const footerTotals = calculateFooterTotals();

//   // Calculate table row percentages
//   const calculateRowPercentages = (row) => {
//     const newAfter = parseFloat(row.new_after_revenue || 0);
//     const renewalAfter = parseFloat(row.renewal_after_revenue || 0);
//     const newBefore = parseFloat(row.new_before_revenue || 0);
//     const renewalBefore = parseFloat(row.renewal_before_revenue || 0);

//     const totalAfter = newAfter + renewalAfter;
//     const totalBefore = newBefore + renewalBefore;

//     // Calculate percentages exactly like PHP
//     const totalPercentage = calculatePercentage(totalAfter, totalBefore);
//     const newPercentage = calculatePercentage(newAfter, newBefore);
//     const renewalPercentage = calculatePercentage(renewalAfter, renewalBefore);

//     return {
//       subscribedCount: parseInt(row.subscribed_count || row.count || 0),
//       salesManagerName: row.sales_manager_name,
//       newAfter,
//       renewalAfter,
//       newBefore,
//       renewalBefore,
//       totalAfter,
//       totalBefore,
//       totalPercentage,
//       newPercentage,
//       renewalPercentage
//     };
//   };

//   return (
//     <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
//       <link href="https://research.streetgains.in/dev/app/assets/daterangepicker.css" rel="stylesheet" />

//       {loading && <LoadingSpinner />}

//       {/* Breadcrumb */}
//       <div className="row pb-2">
//         <div className="col-md-3">
//           <ul className="breadcrumb">
//             <li className="breadcrumb-item">
//               <a href="/dashboard" style={{ textDecoration: "none" }}>
//                 <FontAwesomeIcon icon={faHome} /> Home
//               </a>
//             </li>
//             <li className="breadcrumb-item active">Revenue Chart</li>
//           </ul>
//         </div>
//       </div>

//       {/* Main Panel */}
//       <div className="panel panel-default with-rounded-corner with-shadow chartbox">
//         <div className="panel-heading"></div>
//         <div className="panel-body">

//           {/* Filters */}
//           <div className="row">
//             <div className="col-12">
//               <form onSubmit={handleSearch}>
//                 <div className="row align-items-center">
//                   <div className="col-md-2">
//                     <div className="form-group">
//                       <label className="control-label">Pay Date</label>
//                       <DateRangePicker
//                         initialSettings={{
//                           autoUpdateInput: false,
//                           locale: { format: "DD-MM-YYYY", cancelLabel: "Clear" },
//                           ranges: ranges,
//                           startDate: formInputs.screated_on,
//                           endDate: formInputs.ecreated_on,
//                         }}
//                         onApply={handleDateCallback}
//                       >
//                         <div className="input-group">
//                           <input
//                             type="text"
//                             className="form-control"
//                             value={formInputs.created_on}
//                             placeholder="Select Date Range"
//                             readOnly
//                           />
//                           <span className="input-group-addon" style={{ display: "flex", alignItems: "center", padding: "0 10px", background: "#eee", border: "1px solid #ced4da", borderLeft: "none" }}>
//                             <FontAwesomeIcon icon={faCalendarAlt} />
//                           </span>
//                         </div>
//                       </DateRangePicker>
//                     </div>
//                   </div>

//                   <div className="col-md-2">
//                     <div className="form-group">
//                       <label className="control-label">User</label>
//                       <Select
//                         isMulti
//                         options={userList}
//                         value={formInputs.selecteduser}
//                         onChange={handleUserChange}
//                         placeholder="Select User"
//                         classNamePrefix="react-select"
//                       />
//                     </div>
//                   </div>

//                   <div className="col-md-2">
//                     <div className="form-group">
//                       <label className="control-label w-100"></label>
//                       <button type="submit" className="btn btn-default">
//                         <FontAwesomeIcon icon={faSearch} />
//                       </button>
//                     </div>
//                   </div>

//                   <div className="col-md-6">
//                     <button type="button" className="btn btn-default btn-sm pull-right">
//                       <FontAwesomeIcon icon={faDownload} /> Export Report
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>

//           {/* Summary Boxes - FIXED with correct percentages */}
//           <div className="row mb-4">
//             <div className="col-sm-4">
//               <a href="#" className="widget widget-stats bg-gradient-blue-dark inverse-mode">
//                 <div className="widget-stats-left">
//                   <div className="widget-stats-title">Total Revenue</div>
//                 </div>
//                 <div className="widget-stats-right">
//                   <div className="widget-stats-value">
//                     {moneyFormatIndia(summaryData.boxTotalAfterRevenue)}
//                   </div>
//                   <div className="desc-value">
//                     {moneyFormatIndia(summaryData.boxTotalBeforeRevenue)}
//                     {renderPercentageBadge(summaryData.boxTotalPercentage, true)}
//                   </div>
//                 </div>
//               </a>
//             </div>
//             <div className="col-sm-4">
//               <a href="#" className="widget widget-stats bg-gradient-orange inverse-mode">
//                 <div className="widget-stats-left">
//                   <div className="widget-stats-title">New Revenue</div>
//                 </div>
//                 <div className="widget-stats-right">
//                   <div className="widget-stats-value">
//                     {moneyFormatIndia(summaryData.boxNewAfterRevenue)}
//                   </div>
//                   <div className="desc-value">
//                     {moneyFormatIndia(summaryData.boxNewBeforeRevenue)}
//                     {renderPercentageBadge(summaryData.boxNewPercentage, true)}
//                   </div>
//                 </div>
//               </a>
//             </div>
//             <div className="col-sm-4">
//               <a href="#" className="widget widget-stats bg-gradient-red inverse-mode">
//                 <div className="widget-stats-left">
//                   <div className="widget-stats-title">Renewal Revenue</div>
//                 </div>
//                 <div className="widget-stats-right">
//                   <div className="widget-stats-value">
//                     {moneyFormatIndia(summaryData.boxRenewalAfterRevenue)}
//                   </div>
//                   <div className="desc-value">
//                     {moneyFormatIndia(summaryData.boxRenewalBeforeRevenue)}
//                     {renderPercentageBadge(summaryData.boxRenewalPercentage, true)}
//                   </div>
//                 </div>
//               </a>
//             </div>
//           </div>

//           {/* Charts Area */}
//           <div className="row">
//             {chartData.servicetype && (
//               <>
//                 <div className="col-sm-6 mb-3">
//                   <div className="pie_chart_wrap">
//                     <div className="pie_chart_div" style={{ height: "300px", position: "relative" }}>
//                       <canvas id="pieChart_servicetype"></canvas>
//                     </div>
//                     <div className="total_value_div text-center">
//                       <label>Total Revenue: <span>{moneyFormatIndia(pieChartTotal)}</span></label>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-sm-6">
//                   <div style={{ height: "300px", position: "relative" }}>
//                     <canvas id="lineChart_servicetype"></canvas>
//                   </div>
//                 </div>
//               </>
//             )}
//           </div>

//           {/* User Revenue Table - FIXED with correct percentages and sorting */}
//           <div className="row mt-5">
//             <div className="col-12">
//               <div className="table-responsive">
//                 <table className="table table-condensed table-hover bg-white">
//                   <thead>
//                     <tr align="center">
//                       <th rowSpan="2" onClick={() => sortBox("user")} style={{ cursor: "pointer" }}>
//                         User <FontAwesomeIcon icon={getSortIcon("user")} />
//                       </th>
//                       <th colSpan="4">Current - {dateLabels.current}</th>
//                       <th rowSpan="2">Difference</th>
//                       <th colSpan="3">Previous - {dateLabels.previous}</th>
//                     </tr>
//                     <tr>
//                       <th onClick={() => sortBox("subscribed_count")} style={{ cursor: "pointer" }}>
//                         New User <FontAwesomeIcon icon={getSortIcon("subscribed_count")} />
//                       </th>
//                       <th onClick={() => sortBox("total_after")} style={{ cursor: "pointer" }}>
//                         Total Revenue <FontAwesomeIcon icon={getSortIcon("total_after")} />
//                       </th>
//                       <th onClick={() => sortBox("new_after")} style={{ cursor: "pointer" }}>
//                         New Revenue <FontAwesomeIcon icon={getSortIcon("new_after")} />
//                       </th>
//                       <th onClick={() => sortBox("renewal_after")} style={{ cursor: "pointer" }}>
//                         Renewal Revenue <FontAwesomeIcon icon={getSortIcon("renewal_after")} />
//                       </th>
//                       <th onClick={() => sortBox("total_before")} style={{ cursor: "pointer" }}>
//                         Total Revenue <FontAwesomeIcon icon={getSortIcon("total_before")} />
//                       </th>
//                       <th onClick={() => sortBox("new_before")} style={{ cursor: "pointer" }}>
//                         New Revenue <FontAwesomeIcon icon={getSortIcon("new_before")} />
//                       </th>
//                       <th onClick={() => sortBox("renewal_before")} style={{ cursor: "pointer" }}>
//                         Renewal Revenue <FontAwesomeIcon icon={getSortIcon("renewal_before")} />
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {sortData(userWiseRevData).map((row, idx) => {
//                       const rowData = calculateRowPercentages(row);

//                       return (
//                         <tr key={idx}>
//                           <td>{rowData.salesManagerName}</td>
//                           <td>{rowData.subscribedCount}</td>
//                           <td data-sort={rowData.totalAfter}>
//                             {moneyFormatIndia(rowData.totalAfter)}
//                           </td>
//                           <td data-sort={rowData.newAfter}>
//                             {moneyFormatIndia(rowData.newAfter)}
//                             {renderPercentageBadge(rowData.newPercentage, false)}
//                           </td>
//                           <td data-sort={rowData.renewalAfter}>
//                             {moneyFormatIndia(rowData.renewalAfter)}
//                             {renderPercentageBadge(rowData.renewalPercentage, false)}
//                           </td>
//                           <td>
//                             {renderPercentageBadge(rowData.totalPercentage, false)}
//                           </td>
//                           <td data-sort={rowData.totalBefore}>
//                             {moneyFormatIndia(rowData.totalBefore)}
//                           </td>
//                           <td data-sort={rowData.newBefore}>
//                             {moneyFormatIndia(rowData.newBefore)}
//                           </td>
//                           <td data-sort={rowData.renewalBefore}>
//                             {moneyFormatIndia(rowData.renewalBefore)}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                   <tfoot>
//                     <tr>
//                       <th>Total</th>
//                       <th>{footerTotals.userTotal}</th>
//                       <th>{moneyFormatIndia(footerTotals.totalAfter)}</th>
//                       <th>{moneyFormatIndia(footerTotals.newAfter)}</th>
//                       <th>{moneyFormatIndia(footerTotals.renewalAfter)}</th>
//                       <th></th>
//                       <th>{moneyFormatIndia(footerTotals.totalBefore)}</th>
//                       <th>{moneyFormatIndia(footerTotals.newBefore)}</th>
//                       <th>{moneyFormatIndia(footerTotals.renewalBefore)}</th>
//                     </tr>
//                   </tfoot>
//                 </table>
//               </div>
//             </div>
//           </div>

//           {/* Month Wise Data */}
//           <div className="row mt-5">
//             {Object.keys(monthWiseArr).length > 0 && Object.entries(monthWiseArr).map(([userId, months]) => {
//               if (typeof months !== 'object' || months === null) return null;

//               const monthEntries = Object.entries(months);
//               if (monthEntries.length === 0) return null;

//               const totals = monthEntries.reduce((acc, [monthKey, data]) => ({
//                 total: acc.total + parseFloat(data.amount || 0),
//                 new: acc.new + parseFloat(data.new_revenue || 0),
//                 renewal: acc.renewal + parseFloat(data.renewal_revenue || 0)
//               }), { total: 0, new: 0, renewal: 0 });

//               const userName = monthEntries[0]?.[1]?.user_fullname || 'Overall Data';

//               return (
//                 <div className="col-md-6 mt-4" key={userId}>
//                   <h4>{formInputs.selecteduser.length === 0 ? 'Overall Data Month Wise' : userName}</h4>
//                   <div className="table-responsive">
//                     <table className="table">
//                       <thead>
//                         <tr>
//                           <th>Months</th>
//                           <th>Total Revenue</th>
//                           <th>New Revenue</th>
//                           <th>Renewal Revenue</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {monthEntries.map(([month, data]) => (
//                           <tr key={month}>
//                             <td>{month}</td>
//                             <td>{moneyFormatIndia(data.amount)}</td>
//                             <td>{moneyFormatIndia(data.new_revenue)}</td>
//                             <td>{moneyFormatIndia(data.renewal_revenue)}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                       <tfoot>
//                         <tr>
//                           <th>Total</th>
//                           <th>{moneyFormatIndia(totals.total)}</th>
//                           <th>{moneyFormatIndia(totals.new)}</th>
//                           <th>{moneyFormatIndia(totals.renewal)}</th>
//                         </tr>
//                       </tfoot>
//                     </table>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//         </div>
//       </div>

//       <style jsx>{`
//         .breadcrumb { background: transparent; margin-bottom: 0; padding: 0; list-style: none; display: flex; align-items: center; }
//         .breadcrumb-item { display: flex; align-items: center; }
//         .breadcrumb-item + .breadcrumb-item::before { content: ">"; padding: 0 8px; color: #6c757d; }
//         .breadcrumb-item a { color: #007bff; text-decoration: none; }
//         .breadcrumb-item.active { color: #6c757d; }

//         .panel { background: white; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
//         .with-rounded-corner { border-radius: 4px; }
//         .with-shadow { box-shadow: 0 1px 3px rgba(0,0,0,0.1); }

//         .widget-stats {
//           padding: 15px; border-radius: 4px; color: white; overflow: hidden; margin-bottom: 20px; min-height: 80px;
//           display: flex; justify-content: space-between; align-items: center; text-decoration: none;
//         }
//         .widget-stats:hover { color: #fff; opacity: 0.95; }
//         .widget-stats-left { text-align: left; }
//         .widget-stats-right { text-align: right; }
//         .widget-stats-title { font-size: 12px; opacity: 0.8; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;}
//         .widget-stats-value { font-size: 24px; font-weight: bold; }
//         .desc-value { font-size: 13px; opacity: 0.9; margin-top: 2px; }

//         .bg-gradient-blue-dark { background: linear-gradient(45deg, #2c3e50, #3498db); }
//         .bg-gradient-orange { background: linear-gradient(45deg, #e67e22, #f39c12); }
//         .bg-gradient-red { background: linear-gradient(45deg, #e74c3c, #c0392b); }
//         .inverse-mode { color: white; }

//         .pie_chart_wrap { position: relative; }
//         .total_value_div { margin-top: 10px; font-weight: bold; }
//         .total_value_div span { font-weight: 700; }

//         .badge { font-size: 0.7em; margin-left: 5px; padding: 3px 6px; border-radius: 4px; }
//         .badge-danger { background-color: #ff5b57; color: #fff; }
//         .badge-success { background-color: #32a932; color: #fff; }

//         .form-group { margin-bottom: 1rem; }
//         .control-label { font-weight: 600; margin-bottom: 0.5rem; display: block; }
//         .btn-default { background-color: #f8f9fa; border-color: #ddd; color: #333; }
//         .btn-default:hover { background-color: #e9ecef; border-color: #ccc; }

//         .input-group { display: flex; width: 100%; }
//         .input-group .form-control { border-top-right-radius: 0; border-bottom-right-radius: 0; cursor: pointer; background: #fff !important; }
//         .input-group-addon { border-top-right-radius: 4px; border-bottom-right-radius: 4px; }

//         table { width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse; }
//         .table-condensed td, .table-condensed th { padding: 5px; }
//         .table-hover tbody tr:hover { color: #212529; background-color: rgba(0,0,0,.075); }
//         .bg-white { background-color: #fff !important; }
//         th { text-align: center; vertical-align: middle !important; border-bottom: 2px solid #dee2e6; }
//         td { text-align: center; vertical-align: middle; border-top: 1px solid #dee2e6; }
//         tfoot th { border-top: 2px solid #dee2e6; }


//         .text-danger { color: #dc3545 !important; }
//         .text-success { color: #28a745 !important; }
//       `}</style>
//     </div>
//   );
// };

// export default RevenueChart;



/* eslint-disable */
import React, { useEffect, useState, useRef, useCallback } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faSearch,
  faHome,
  faArrowUp,
  faArrowDown,
  faCalendarAlt,
  faSortUp,
  faSortDown,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { API_URL } from "../../config";
import LoadingSpinner from "../../components/LoadingSpinner.jsx";
import moment from "moment";
import { Chart, registerables } from "chart.js";
import Select from "react-select";

Chart.register(...registerables);

const RevenueChart = () => {
  const [loading, setLoading] = useState(false);

  // Granular loading states
  const [loadingStates, setLoadingStates] = useState({
    summary: false,
    charts: false,
    table: false,
    monthData: false,
    userList: false,
  });

  // Data States
  const [userList, setUserList] = useState([]);
  const [chartData, setChartData] = useState({});
  const [userWiseRevData, setUserWiseRevData] = useState([]);
  const [monthWiseArr, setMonthWiseArr] = useState({});
  const [serviceCountData, setServiceCountData] = useState({});
  const [allDates, setAllDates] = useState([]);

  // Sorting States
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  // Meta Data for display
  const [dateLabels, setDateLabels] = useState({
    current: "",
    previous: ""
  });

  // Chart References
  const chartInstances = useRef({});

  // --- Date Logic: Default to Current Week ---
  const defaultStart = moment().startOf("isoWeek");
  const defaultEnd = moment().endOf("isoWeek");
  const defaultLabel = `${defaultStart.format("DD-MM-YYYY")} - ${defaultEnd.format("DD-MM-YYYY")}`;

  // Form State
  const [formInputs, setFormInputs] = useState({
    created_on: defaultLabel,
    screated_on: defaultStart,
    ecreated_on: defaultEnd,
    selecteduser: [],
  });

  // Ranges configuration
  const ranges = {
    "This Week": [moment().startOf("isoWeek"), moment().endOf("isoWeek")],
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "This Year": [moment().startOf("year"), moment().endOf("year")],
    "Last Year": [
      moment().subtract(1, "year").startOf("year"),
      moment().subtract(1, "year").endOf("year"),
    ],
  };

  // Function to update loading state
  const updateLoadingState = (key, value) => {
    setLoadingStates(prev => ({ ...prev, [key]: value }));
  };

  // Helper: Money Format
  const moneyFormatIndia = (amount) => {
    if (amount === null || amount === undefined || amount === "") return "0.00";
    const num = parseFloat(amount);
    if (isNaN(num)) return "0.00";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  // 1. Fetch User List (GET)
  // 1. Fetch User List (GET)
  const fetchUserList = async () => {
    try {
      updateLoadingState('userList', true);
      const token = localStorage.getItem("authToken");
      const response = await axios.get(`${API_URL}report-revenue/revenue/user-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          accept: "*/*",
        },
      });

      if (response.data && Array.isArray(response.data)) {
        const options = response.data.map((user) => ({
          value: user.id,
          label: user.user_fullname,
        }));
        setUserList(options);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      updateLoadingState('userList', false);
    }
  };

  // 2. Fetch Chart Data (POST)
  const fetchRevenueChartData = async () => {
    try {
      setLoading(true);

      // Set only relevant loading states to true (EXCLUDE userList)
      setLoadingStates(prev => ({
        ...prev,
        summary: true,
        charts: true,
        table: true,
        monthData: true
        // userList should remain as-is (don't reset it)
      }));

      const token = localStorage.getItem("authToken");

      const payload = {
        created_on: formInputs.created_on,
        selecteduser: formInputs.selecteduser.length > 0
          ? formInputs.selecteduser.map(u => u.value).join(',')
          : ""
      };

      const response = await axios.post(
        `${API_URL}report-revenue/revenue/chart`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            accept: "*/*",
          },
        }
      );

      if (response.data) {
        const data = response.data;

        setChartData(data.chartData || {});
        setUserWiseRevData(data.userWiseRevData || []);
        setMonthWiseArr(data.monthWiseArr || {});
        setServiceCountData(data.serviceCountData || {});
        setAllDates(data.allDates || []);

        setDateLabels({
          current: `${data.spay_date || ''} to ${data.epay_date || ''}`,
          previous: `${data.prev_spay_date || ''} to ${data.prev_epay_date || ''}`
        });

        // Update loading states (EXCLUDE userList)
        setLoadingStates(prev => ({
          ...prev,
          summary: false,
          charts: false,
          table: false,
          monthData: false
        }));
      }
    } catch (error) {
      console.error("Error fetching chart data:", error);

      // On error, only reset the relevant loading states (EXCLUDE userList)
      setLoadingStates(prev => ({
        ...prev,
        summary: false,
        charts: false,
        table: false,
        monthData: false
      }));
    } finally {
      setLoading(false);
    }
  };

  // Initial Load
  useEffect(() => {
    fetchUserList();
    fetchRevenueChartData();
    // eslint-disable-next-line
  }, []);

  // Chart Lifecycle
  useEffect(() => {
    if (chartData && Object.keys(chartData).length > 0 && allDates.length > 0 && !loadingStates.charts) {
      renderCharts();
    }
    return () => {
      Object.values(chartInstances.current).forEach((chart) => {
        if (chart && typeof chart.destroy === 'function') {
          chart.destroy();
        }
      });
      chartInstances.current = {};
    };
    // eslint-disable-next-line
  }, [chartData, allDates, loadingStates.charts]);

  const renderCharts = () => {
    // We only expect 'servicetype' based on the PHP code
    const key = 'servicetype';
    if (!chartData[key]) return;

    const currentData = chartData[key];

    // 1. Pie Chart
    const pieCtx = document.getElementById(`pieChart_${key}`);
    if (pieCtx) {
      if (chartInstances.current[`pie_${key}`]) {
        chartInstances.current[`pie_${key}`].destroy();
      }

      // Calculate pie chart data - sum of all piedata arrays
      const pieLabels = Object.keys(currentData);
      const pieData = pieLabels.map(label => {
        const piedata = currentData[label].piedata;
        if (Array.isArray(piedata)) {
          return piedata.reduce((sum, val) => sum + parseFloat(val || 0), 0);
        }
        return parseFloat(piedata || 0);
      });
      const pieColors = pieLabels.map(label => currentData[label].color);

      chartInstances.current[`pie_${key}`] = new Chart(pieCtx, {
        type: 'pie',
        data: {
          labels: pieLabels,
          datasets: [{
            data: pieData,
            backgroundColor: pieColors
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'bottom' },
            title: { display: true, text: 'Service Type' }
          }
        }
      });
    }

    // 2. Bar Chart
    const lineCtx = document.getElementById(`lineChart_${key}`);
    if (lineCtx) {
      if (chartInstances.current[`line_${key}`]) {
        chartInstances.current[`line_${key}`].destroy();
      }

      // Transform data for Bar Chart
      const datasets = Object.entries(currentData).map(([label, val]) => {
        let dataArray = [];
        if (typeof val.data === 'string') {
          // Split comma-separated string and convert to numbers
          dataArray = val.data.split(',').map(num => parseFloat(num || 0));
        } else if (Array.isArray(val.data)) {
          dataArray = val.data.map(num => parseFloat(num || 0));
        }

        // Ensure data array length matches allDates length
        while (dataArray.length < allDates.length) {
          dataArray.push(0);
        }

        return {
          label: label,
          backgroundColor: val.color,
          data: dataArray.slice(0, allDates.length)
        };
      });

      chartInstances.current[`line_${key}`] = new Chart(lineCtx, {
        type: 'bar',
        data: {
          labels: allDates,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'bottom' },
            title: { display: true, text: 'Service Type' },
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  if (context.parsed.y !== null) {
                    label += moneyFormatIndia(context.parsed.y);
                  }
                  return label;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: true,
              grid: { display: false },
              ticks: {
                maxRotation: 45,
                minRotation: 45
              }
            },
            y: {
              stacked: true,
              beginAtZero: true,
              ticks: {
                callback: function (value) {
                  return moneyFormatIndia(value);
                }
              }
            }
          }
        }
      });
    }
  };

  // --- Handlers ---

  const handleDateCallback = (event, picker) => {
    const start = picker.startDate;
    const end = picker.endDate;
    const dateValue = `${start.format("DD-MM-YYYY")} - ${end.format("DD-MM-YYYY")}`;

    setFormInputs((prev) => ({
      ...prev,
      created_on: dateValue,
      screated_on: start,
      ecreated_on: end,
    }));
  };

  const handleUserChange = (selected) => {
    setFormInputs((prev) => ({ ...prev, selecteduser: selected || [] }));
  };

  const handleSearch = (e) => {
    e.preventDefault();

    // Don't modify userList loading state here
    setLoadingStates(prev => ({
      ...prev,
      summary: true,
      charts: true,
      table: true,
      monthData: true
    }));

    fetchRevenueChartData();
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const payload = {
        created_on: formInputs.created_on,
        selecteduser: formInputs.selecteduser.length > 0
          ? formInputs.selecteduser.map(u => u.value).join(",")
          : "",
      };

      const response = await axios.post(
        `${API_URL}report-revenue/revenue/export/chart`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            accept: "*/*",
          },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Revenue_Report_${moment().format("DD_MM_YYYY")}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exporting report:", error);
    } finally {
      setLoading(false);
    }
  };

  // --- Sorting Functions ---

  const sortBox = (field) => {
    if (sortField === field) {
      // Toggle sort order if same field
      const newOrder = sortOrder === "asc" ? "desc" : "asc";
      setSortOrder(newOrder);
    } else {
      // Set new field with ascending order
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField === field) {
      return sortOrder === "asc" ? faSortUp : faSortDown;
    }
    return faSort; // default icon for inactive columns
  };

  const sortData = (data) => {
    if (!sortField || !sortOrder) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (sortField) {
        case "user":
          aValue = a.sales_manager_name || "";
          bValue = b.sales_manager_name || "";
          break;
        case "subscribed_count":
          aValue = parseInt(a.subscribed_count || a.count || 0);
          bValue = parseInt(b.subscribed_count || b.count || 0);
          break;
        case "total_after":
          aValue = parseFloat(a.new_after_revenue || 0) + parseFloat(a.renewal_after_revenue || 0);
          bValue = parseFloat(b.new_after_revenue || 0) + parseFloat(b.renewal_after_revenue || 0);
          break;
        case "new_after":
          aValue = parseFloat(a.new_after_revenue || 0);
          bValue = parseFloat(b.new_after_revenue || 0);
          break;
        case "renewal_after":
          aValue = parseFloat(a.renewal_after_revenue || 0);
          bValue = parseFloat(b.renewal_after_revenue || 0);
          break;
        case "total_before":
          aValue = parseFloat(a.new_before_revenue || 0) + parseFloat(a.renewal_before_revenue || 0);
          bValue = parseFloat(b.new_before_revenue || 0) + parseFloat(b.renewal_before_revenue || 0);
          break;
        case "new_before":
          aValue = parseFloat(a.new_before_revenue || 0);
          bValue = parseFloat(b.new_before_revenue || 0);
          break;
        case "renewal_before":
          aValue = parseFloat(a.renewal_before_revenue || 0);
          bValue = parseFloat(b.renewal_before_revenue || 0);
          break;
        default:
          return 0;
      }

      // Handle string comparison
      if (typeof aValue === "string") {
        return sortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      // Handle numeric comparison
      return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
    });
  };

  // --- CORRECTED Percentage Calculation Logic (Matching PHP exactly) ---

  const calculatePercentage = (afterValue, beforeValue) => {
    // Convert to numbers
    const after = parseFloat(afterValue) || 0;
    const before = parseFloat(beforeValue) || 0;

    // IMPORTANT: PHP logic - Only calculate if BOTH values are non-zero
    if (after !== 0 && before !== 0) {
      return ((after - before) / before) * 100;
    }
    return 0;
  };

  const formatPercentage = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return "0.00";
    return num.toFixed(2);
  };

  const renderPercentageBadge = (percentage, isLeftSide = false) => {
    const perc = parseFloat(percentage);

    // Don't show if percentage is 0
    if (perc === 0) return null;

    const isNegative = perc < 0;
    const className = isNegative
      ? "badge badge-danger font-weight-normal"
      : "badge badge-success font-weight-normal";
    const icon = isNegative ? faArrowDown : faArrowUp;
    const sign = perc < 0 ? "" : "+";
    const displayValue = formatPercentage(perc);

    if (isLeftSide) {
      // For left side display (in summary boxes)
      return (
        <span className={className} style={{ marginLeft: '5px', fontSize: '0.75em' }}>
          <FontAwesomeIcon icon={icon} /> ({sign}{displayValue}%)
        </span>
      );
    } else {
      // For right side display (in table)
      return (
        <span className={isNegative ? "text-danger" : "text-success"} style={{ marginLeft: '5px' }}>
          <FontAwesomeIcon icon={icon} /> ({sign}{displayValue}%)
        </span>
      );
    }
  };

  // Summary Box Calculations - CORRECTED to match PHP exactly
  const calculateSummaryData = () => {
    const boxNewAfterRevenue = parseFloat(serviceCountData.new_after_revenue || 0);
    const boxRenewalAfterRevenue = parseFloat(serviceCountData.renewal_after_revenue || 0);
    const boxTotalAfterRevenue = boxNewAfterRevenue + boxRenewalAfterRevenue;

    const boxNewBeforeRevenue = parseFloat(serviceCountData.new_before_revenue || 0);
    const boxRenewalBeforeRevenue = parseFloat(serviceCountData.renewal_before_revenue || 0);
    const boxTotalBeforeRevenue = boxNewBeforeRevenue + boxRenewalBeforeRevenue;

    // Calculate percentages exactly like PHP
    const boxTotalPercentage = calculatePercentage(boxTotalAfterRevenue, boxTotalBeforeRevenue);
    const boxNewPercentage = calculatePercentage(boxNewAfterRevenue, boxNewBeforeRevenue);
    const boxRenewalPercentage = calculatePercentage(boxRenewalAfterRevenue, boxRenewalBeforeRevenue);

    return {
      boxNewAfterRevenue,
      boxRenewalAfterRevenue,
      boxTotalAfterRevenue,
      boxNewBeforeRevenue,
      boxRenewalBeforeRevenue,
      boxTotalBeforeRevenue,
      boxTotalPercentage,
      boxNewPercentage,
      boxRenewalPercentage
    };
  };

  const summaryData = calculateSummaryData();

  // Calculate pie chart total for display
  const pieChartTotal = chartData.servicetype ?
    Object.values(chartData.servicetype).reduce((sum, item) => {
      if (Array.isArray(item.piedata)) {
        return sum + item.piedata.reduce((a, b) => parseFloat(a || 0) + parseFloat(b || 0), 0);
      }
      return sum + parseFloat(item.piedata || 0);
    }, 0) : 0;

  // Table Footer Calculations
  const calculateFooterTotals = () => {
    return userWiseRevData.reduce((acc, row) => {
      const subscribedCount = parseInt(row.subscribed_count || row.count || 0);
      const newAfter = parseFloat(row.new_after_revenue || 0);
      const renewalAfter = parseFloat(row.renewal_after_revenue || 0);
      const newBefore = parseFloat(row.new_before_revenue || 0);
      const renewalBefore = parseFloat(row.renewal_before_revenue || 0);
      const totalAfterResearch = parseFloat(row.new_after_research_fee || 0) + parseFloat(row.renewal_after_research_fee || 0);
      const totalBeforeResearch = parseFloat(row.new_before_research_fee || 0) + parseFloat(row.renewal_before_research_fee || 0);
      const totalAfterTax = parseFloat(row.new_after_tax_amt || 0) + parseFloat(row.renewal_after_tax_amt || 0);
      const totalBeforeTax = parseFloat(row.new_before_tax_amt || 0) + parseFloat(row.renewal_before_tax_amt || 0);

      return {
        userTotal: acc.userTotal + (isNaN(subscribedCount) ? 0 : subscribedCount),
        totalAfter: acc.totalAfter + (newAfter + renewalAfter),
        newAfter: acc.newAfter + newAfter,
        renewalAfter: acc.renewalAfter + renewalAfter,
        totalBefore: acc.totalBefore + (newBefore + renewalBefore),
        newBefore: acc.newBefore + newBefore,
        renewalBefore: acc.renewalBefore + renewalBefore,
        totalAfterResearch: acc.totalAfterResearch + totalAfterResearch,
        totalBeforeResearch: acc.totalBeforeResearch + totalBeforeResearch,
        totalAfterTax: acc.totalAfterTax + totalAfterTax,
        totalBeforeTax: acc.totalBeforeTax + totalBeforeTax,
      };
    }, {
      userTotal: 0,
      totalAfter: 0,
      newAfter: 0,
      renewalAfter: 0,
      totalBefore: 0,
      newBefore: 0,
      renewalBefore: 0,
      totalAfterResearch: 0,
      totalBeforeResearch: 0,
      totalAfterTax: 0,
      totalBeforeTax: 0
    });
  };

  const footerTotals = calculateFooterTotals();

  // Calculate table row percentages
  const calculateRowPercentages = (row) => {
    const newAfter = parseFloat(row.new_after_revenue || 0);
    const renewalAfter = parseFloat(row.renewal_after_revenue || 0);
    const newBefore = parseFloat(row.new_before_revenue || 0);
    const renewalBefore = parseFloat(row.renewal_before_revenue || 0);

    const totalAfter = newAfter + renewalAfter;
    const totalBefore = newBefore + renewalBefore;
    const totalAfterResearch = parseFloat(row.new_after_research_fee || 0);
    const totalBeforeResearch = parseFloat(row.new_before_research_fee || 0);
    const totalAfterTax = parseFloat(row.new_after_tax_amt || 0);
    const totalBeforeTax = parseFloat(row.new_before_tax_amt || 0);

    // Calculate percentages exactly like PHP
    const totalPercentage = calculatePercentage(totalAfter, totalBefore);
    const newPercentage = calculatePercentage(newAfter, newBefore);
    const renewalPercentage = calculatePercentage(renewalAfter, renewalBefore);

    return {
      subscribedCount: parseInt(row.subscribed_count || row.count || 0),
      salesManagerName: row.sales_manager_name,
      newAfter,
      renewalAfter,
      newBefore,
      renewalBefore,
      totalAfter,
      totalBefore,
      totalAfterResearch,
      totalBeforeResearch,
      totalAfterTax,
      totalBeforeTax,
      totalPercentage,
      newPercentage,
      renewalPercentage
    };
  };

  // Skeleton loader for summary cards
  const SummarySkeleton = () => (
    <div className="row mb-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <div className="col-sm-4" key={index}>
          <div className="widget widget-stats bg-gradient-skeleton skeleton-card">
            <div className="widget-stats-left">
              <div className="skeleton-text" style={{ width: "80%", height: "14px", marginBottom: "8px" }}></div>
            </div>
            <div className="widget-stats-right">
              <div className="skeleton-text" style={{ width: "60%", height: "24px", marginBottom: "5px" }}></div>
              <div className="skeleton-text" style={{ width: "70%", height: "14px" }}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  // Skeleton loader for charts
  const ChartSkeleton = () => (
    <div className="row">
      <div className="col-sm-6 mb-3">
        <div className="pie_chart_wrap">
          <div className="pie_chart_div" style={{ height: "300px", position: "relative" }}>
            <div className="skeleton-chart" style={{ height: "100%", width: "100%" }}>
              <div className="skeleton-pie-chart"></div>
            </div>
          </div>
          <div className="total_value_div text-center">
            <div className="skeleton-text" style={{ width: "120px", height: "18px", margin: "10px auto" }}></div>
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div style={{ height: "300px", position: "relative" }}>
          <div className="skeleton-chart" style={{ height: "100%", width: "100%" }}>
            <div className="skeleton-bar-chart"></div>
          </div>
        </div>
      </div>
    </div>
  );

  // Skeleton loader for table
  const TableSkeleton = () => (
    <div className="row mt-5">
      <div className="col-12">
        <div className="table-responsive">
          <table className="table table-condensed table-hover bg-white">
            <thead>
              <tr align="center">
                <th rowSpan="2">
                  <div className="skeleton-text" style={{ width: "80px", height: "16px", margin: "0 auto" }}></div>
                </th>
                {Array.from({ length: 7 }).map((_, index) => (
                  <th key={index}>
                    <div className="skeleton-text" style={{ width: "100px", height: "16px", margin: "0 auto" }}></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 5 }).map((_, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <div className="skeleton-text" style={{ width: "100px", height: "16px", margin: "0 auto" }}></div>
                  </td>
                  {Array.from({ length: 8 }).map((_, colIndex) => (
                    <td key={colIndex}>
                      <div className="skeleton-text" style={{ width: "80px", height: "16px", margin: "0 auto" }}></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  // Skeleton loader for month-wise data
  const MonthDataSkeleton = () => (
    <div className="row mt-5">
      {Array.from({ length: 2 }).map((_, index) => (
        <div className="col-md-6 mt-4" key={index}>
          <div className="skeleton-text" style={{ width: "200px", height: "24px", marginBottom: "15px" }}></div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th><div className="skeleton-text" style={{ width: "80px", height: "16px" }}></div></th>
                  <th><div className="skeleton-text" style={{ width: "100px", height: "16px" }}></div></th>
                  <th><div className="skeleton-text" style={{ width: "100px", height: "16px" }}></div></th>
                  <th><div className="skeleton-text" style={{ width: "100px", height: "16px" }}></div></th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 3 }).map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    <td><div className="skeleton-text" style={{ width: "70px", height: "16px" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "90px", height: "16px" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "90px", height: "16px" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "90px", height: "16px" }}></div></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
      <link href="https://research.streetgains.in/dev/app/assets/daterangepicker.css" rel="stylesheet" />

      {loading && <LoadingSpinner />}

      {/* Breadcrumb */}
      <div className="row pb-2">
        <div className="col-md-3">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/dashboard" style={{ textDecoration: "none" }}>
                <FontAwesomeIcon icon={faHome} /> Home
              </a>
            </li>
            <li className="breadcrumb-item active">Revenue Chart</li>
          </ul>
        </div>
      </div>

      {/* Main Panel */}
      <div className="panel panel-default with-rounded-corner with-shadow chartbox">
        <div className="panel-heading"></div>
        <div className="panel-body">

          {/* Filters */}
          <div className="row">
            <div className="col-12">
              <form onSubmit={handleSearch}>
                <div className="row align-items-center">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="control-label">Pay Date</label>
                      <DateRangePicker
                        initialSettings={{
                          autoUpdateInput: false,
                          locale: { format: "DD-MM-YYYY", cancelLabel: "Clear" },
                          ranges: ranges,
                          startDate: formInputs.screated_on,
                          endDate: formInputs.ecreated_on,
                        }}
                        onApply={handleDateCallback}
                      >
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            value={formInputs.created_on}
                            placeholder="Select Date Range"
                            readOnly
                          />
                          <span className="input-group-addon" style={{ display: "flex", alignItems: "center", padding: "0 10px", background: "#eee", border: "1px solid #ced4da", borderLeft: "none" }}>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </span>
                        </div>
                      </DateRangePicker>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="control-label">User</label>
                      {loadingStates.userList ? (
                        <div className="skeleton-text" style={{ width: "100%", height: "38px", borderRadius: "4px" }}></div>
                      ) : (
                        <Select
                          isMulti
                          options={userList}
                          value={formInputs.selecteduser}
                          onChange={handleUserChange}
                          placeholder="Select User"
                          classNamePrefix="react-select"
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="control-label w-100"></label>
                      <button type="submit" className="btn btn-default">
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <button 
                      type="button" 
                      className="btn btn-default btn-sm pull-right"
                      onClick={handleExport}
                    >
                      <FontAwesomeIcon icon={faDownload} /> Export Report
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Summary Boxes with Skeleton Loading */}
          {loadingStates.summary ? (
            <SummarySkeleton />
          ) : (
            <div className="row mb-4">
              <div className="col-sm-4">
                <a href="#" className="widget widget-stats bg-gradient-blue-dark inverse-mode">
                  <div className="widget-stats-left">
                    <div className="widget-stats-title">Total Revenue</div>
                  </div>
                  <div className="widget-stats-right">
                    <div className="widget-stats-value">
                      {moneyFormatIndia(summaryData.boxTotalAfterRevenue)}
                    </div>
                    <div className="desc-value">
                      {moneyFormatIndia(summaryData.boxTotalBeforeRevenue)}
                      {renderPercentageBadge(summaryData.boxTotalPercentage, true)}
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-sm-4">
                <a href="#" className="widget widget-stats bg-gradient-orange inverse-mode">
                  <div className="widget-stats-left">
                    <div className="widget-stats-title">New Revenue</div>
                  </div>
                  <div className="widget-stats-right">
                    <div className="widget-stats-value">
                      {moneyFormatIndia(summaryData.boxNewAfterRevenue)}
                    </div>
                    <div className="desc-value">
                      {moneyFormatIndia(summaryData.boxNewBeforeRevenue)}
                      {renderPercentageBadge(summaryData.boxNewPercentage, true)}
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-sm-4">
                <a href="#" className="widget widget-stats bg-gradient-red inverse-mode">
                  <div className="widget-stats-left">
                    <div className="widget-stats-title">Renewal Revenue</div>
                  </div>
                  <div className="widget-stats-right">
                    <div className="widget-stats-value">
                      {moneyFormatIndia(summaryData.boxRenewalAfterRevenue)}
                    </div>
                    <div className="desc-value">
                      {moneyFormatIndia(summaryData.boxRenewalBeforeRevenue)}
                      {renderPercentageBadge(summaryData.boxRenewalPercentage, true)}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          )}

          {/* Charts Area with Skeleton Loading */}
          {loadingStates.charts ? (
            <ChartSkeleton />
          ) : chartData.servicetype ? (
            <div className="row">
              <div className="col-sm-6 mb-3">
                <div className="pie_chart_wrap">
                  <div className="pie_chart_div" style={{ height: "300px", position: "relative" }}>
                    <canvas id="pieChart_servicetype"></canvas>
                  </div>
                  <div className="total_value_div text-center">
                    <label>Total Revenue: <span>{moneyFormatIndia(pieChartTotal)}</span></label>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div style={{ height: "300px", position: "relative" }}>
                  <canvas id="lineChart_servicetype"></canvas>
                </div>
              </div>
            </div>
          ) : null}

          {/* User Revenue Table with Skeleton Loading */}
          {loadingStates.table ? (
            <TableSkeleton />
          ) : (
            <div className="row mt-5">
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-condensed table-hover bg-white">
                    <thead>
                      <tr align="center">
                        <th rowSpan="2" onClick={() => sortBox("user")} style={{ cursor: "pointer" }}>
                          User <FontAwesomeIcon icon={getSortIcon("user")} />
                        </th>
                        <th colSpan="6">Current - {dateLabels.current}</th>
                        <th rowSpan="2">Difference</th>
                        <th colSpan="5">Previous - {dateLabels.previous}</th>
                      </tr>
                      <tr>
                        <th onClick={() => sortBox("subscribed_count")} style={{ cursor: "pointer" }}>
                          New User <FontAwesomeIcon icon={getSortIcon("subscribed_count")} />
                        </th>
                        <th onClick={() => sortBox("total_after")} style={{ cursor: "pointer" }}>
                          Total Revenue <FontAwesomeIcon icon={getSortIcon("total_after")} />
                        </th>
                        <th>
                          Research Fee 
                        </th>
                        <th>
                          Tax
                        </th>
                        <th onClick={() => sortBox("new_after")} style={{ cursor: "pointer" }}>
                          New Revenue <FontAwesomeIcon icon={getSortIcon("new_after")} />
                        </th>
                        <th onClick={() => sortBox("renewal_after")} style={{ cursor: "pointer" }}>
                          Renewal Revenue <FontAwesomeIcon icon={getSortIcon("renewal_after")} />
                        </th>
                        <th onClick={() => sortBox("total_before")} style={{ cursor: "pointer" }}>
                          Total Revenue <FontAwesomeIcon icon={getSortIcon("total_before")} />
                        </th>
                        <th>
                          Research Fee 
                        </th>
                        <th>
                          Tax
                        </th>
                        <th onClick={() => sortBox("new_before")} style={{ cursor: "pointer" }}>
                          New Revenue <FontAwesomeIcon icon={getSortIcon("new_before")} />
                        </th>
                        <th onClick={() => sortBox("renewal_before")} style={{ cursor: "pointer" }}>
                          Renewal Revenue <FontAwesomeIcon icon={getSortIcon("renewal_before")} />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortData(userWiseRevData).map((row, idx) => {
                        const rowData = calculateRowPercentages(row);

                        return (
                          <tr key={idx}>
                            <td>{rowData.salesManagerName}</td>
                            <td>{rowData.subscribedCount}</td>
                            <td data-sort={rowData.totalAfter}>
                              {moneyFormatIndia(rowData.totalAfter)}
                            </td>
                             <td data-sort={rowData.totalAfterResearch}>
                              {moneyFormatIndia(rowData.totalAfterResearch)}
                            </td>
                            
                             <td data-sort={rowData.totalAfterTax}>
                              {moneyFormatIndia(rowData.totalAfterTax)}
                            </td>
                            <td data-sort={rowData.newAfter}>
                              {moneyFormatIndia(rowData.newAfter)}
                              {renderPercentageBadge(rowData.newPercentage, false)}
                            </td>
                            <td data-sort={rowData.renewalAfter}>
                              {moneyFormatIndia(rowData.renewalAfter)}
                              {renderPercentageBadge(rowData.renewalPercentage, false)}
                            </td>
                            <td>
                              {renderPercentageBadge(rowData.totalPercentage, false)}
                            </td>
                            <td data-sort={rowData.totalBefore}>
                              {moneyFormatIndia(rowData.totalBefore)}
                            </td>
                            <td data-sort={rowData.totalBeforeResearch}>
                              {moneyFormatIndia(rowData.totalBeforeResearch)}
                            </td>
                            <td data-sort={rowData.totalBeforeTax}>
                              {moneyFormatIndia(rowData.totalBeforeTax)}
                            </td>
                            <td data-sort={rowData.newBefore}>
                              {moneyFormatIndia(rowData.newBefore)}
                            </td>
                            <td data-sort={rowData.renewalBefore}>
                              {moneyFormatIndia(rowData.renewalBefore)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>Total</th>
                        <th>{footerTotals.userTotal}</th>
                        <th>{moneyFormatIndia(footerTotals.totalAfter)}</th>
                        <th>{moneyFormatIndia(footerTotals.totalAfterResearch)}</th>
                        <th>{moneyFormatIndia(footerTotals.totalAfterTax)}</th>
                        <th>{moneyFormatIndia(footerTotals.newAfter)}</th>
                        <th>{moneyFormatIndia(footerTotals.renewalAfter)}</th>
                        <th></th>
                        <th>{moneyFormatIndia(footerTotals.totalBefore)}</th>
                        <th>{moneyFormatIndia(footerTotals.totalBeforeResearch)}</th>
                        <th>{moneyFormatIndia(footerTotals.totalBeforeTax)}</th>
                        <th>{moneyFormatIndia(footerTotals.newBefore)}</th>
                        <th>{moneyFormatIndia(footerTotals.renewalBefore)}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* Month Wise Data with Skeleton Loading */}
          {loadingStates.monthData ? (
            <MonthDataSkeleton />
          ) : Object.keys(monthWiseArr).length > 0 ? (
            <div className="row mt-5">
              {Object.entries(monthWiseArr).map(([userId, months]) => {
                if (typeof months !== 'object' || months === null) return null;

                const monthEntries = Object.entries(months);
                if (monthEntries.length === 0) return null;

                const totals = monthEntries.reduce((acc, [monthKey, data]) => ({
                  total: acc.total + parseFloat(data.amount || 0),
                  new: acc.new + parseFloat(data.new_revenue || 0),
                  renewal: acc.renewal + parseFloat(data.renewal_revenue || 0)
                }), { total: 0, new: 0, renewal: 0 });

                const userName = monthEntries[0]?.[1]?.user_fullname || 'Overall Data';

                return (
                  <div className="col-md-6 mt-4" key={userId}>
                    <h4>{formInputs.selecteduser.length === 0 ? 'Overall Data Month Wise' : userName}</h4>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Months</th>
                            <th>Total Revenue</th>
                            <th>New Revenue</th>
                            <th>Renewal Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {monthEntries.map(([month, data]) => (
                            <tr key={month}>
                              <td>{month}</td>
                              <td>{moneyFormatIndia(data.amount)}</td>
                              <td>{moneyFormatIndia(data.new_revenue)}</td>
                              <td>{moneyFormatIndia(data.renewal_revenue)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>Total</th>
                            <th>{moneyFormatIndia(totals.total)}</th>
                            <th>{moneyFormatIndia(totals.new)}</th>
                            <th>{moneyFormatIndia(totals.renewal)}</th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}

        </div>
      </div>

      <style jsx>{`
        .breadcrumb { background: transparent; margin-bottom: 0; padding: 0; list-style: none; display: flex; align-items: center; }
        .breadcrumb-item { display: flex; align-items: center; }
        .breadcrumb-item + .breadcrumb-item::before { content: ">"; padding: 0 8px; color: #6c757d; }
        .breadcrumb-item a { color: #007bff; text-decoration: none; }
        .breadcrumb-item.active { color: #6c757d; }

        .panel { background: white; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
        .with-rounded-corner { border-radius: 4px; }
        .with-shadow { box-shadow: 0 1px 3px rgba(0,0,0,0.1); }

        .widget-stats {
          padding: 15px; border-radius: 4px; color: white; overflow: hidden; margin-bottom: 20px; min-height: 80px;
          display: flex; justify-content: space-between; align-items: center; text-decoration: none;
        }
        .widget-stats:hover { color: #fff; opacity: 0.95; }
        .widget-stats-left { text-align: left; }
        .widget-stats-right { text-align: right; }
        .widget-stats-title { font-size: 12px; opacity: 0.8; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;}
        .widget-stats-value { font-size: 24px; font-weight: bold; }
        .desc-value { font-size: 13px; opacity: 0.9; margin-top: 2px; }

        .bg-gradient-blue-dark { background: linear-gradient(45deg, #2c3e50, #3498db); }
        .bg-gradient-orange { background: linear-gradient(45deg, #e67e22, #f39c12); }
        .bg-gradient-red { background: linear-gradient(45deg, #e74c3c, #c0392b); }
        .inverse-mode { color: white; }

        /* Skeleton Loading Styles */
        .skeleton-text {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s ease-in-out infinite;
          border-radius: 4px;
          display: inline-block;
        }

        .skeleton-card {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          ) !important;
          background-size: 200% 100% !important;
          animation: skeleton-loading 1.5s ease-in-out infinite !important;
          min-height: 80px;
        }

        .skeleton-chart {
          position: relative;
          overflow: hidden;
          border-radius: 4px;
          background: #f8f9fa;
        }

        .skeleton-pie-chart,
        .skeleton-bar-chart {
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s ease-in-out infinite;
        }

        .skeleton-pie-chart {
          border-radius: 50%;
          width: 70% !important;
          height: 70% !important;
          margin: 15% auto;
        }

        .skeleton-bar-chart {
          display: flex;
          align-items: flex-end;
          justify-content: space-around;
          padding: 30px 20px;
        }

        .skeleton-bar-chart::before,
        .skeleton-bar-chart::after {
          content: '';
          width: 15%;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s ease-in-out infinite;
          border-radius: 4px;
        }

        .skeleton-bar-chart::before {
          height: 60%;
        }

        .skeleton-bar-chart::after {
          height: 80%;
        }

        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        .pie_chart_wrap { position: relative; }
        .total_value_div { margin-top: 10px; font-weight: bold; }
        .total_value_div span { font-weight: 700; }

        .badge { font-size: 0.7em; margin-left: 5px; padding: 3px 6px; border-radius: 4px; }
        .badge-danger { background-color: #ff5b57; color: #fff; }
        .badge-success { background-color: #32a932; color: #fff; }
        
        .form-group { margin-bottom: 1rem; }
        .control-label { font-weight: 600; margin-bottom: 0.5rem; display: block; }
        .btn-default { background-color: #f8f9fa; border-color: #ddd; color: #333; }
        .btn-default:hover { background-color: #e9ecef; border-color: #ccc; }

        .input-group { display: flex; width: 100%; }
        .input-group .form-control { border-top-right-radius: 0; border-bottom-right-radius: 0; cursor: pointer; background: #fff !important; }
        .input-group-addon { border-top-right-radius: 4px; border-bottom-right-radius: 4px; }
        
        table { width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse; }
        .table-condensed td, .table-condensed th { padding: 5px; }
        .table-hover tbody tr:hover { color: #212529; background-color: rgba(0,0,0,.075); }
        .bg-white { background-color: #fff !important; }
        th { text-align: center; vertical-align: middle !important; border-bottom: 2px solid #dee2e6; }
        td { text-align: center; vertical-align: middle; border-top: 1px solid #dee2e6; }
        tfoot th { border-top: 2px solid #dee2e6; }

        .text-danger { color: #dc3545 !important; }
        .text-success { color: #28a745 !important; }
      `}</style>
    </div>
  );
};

export default RevenueChart;